
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/data-scientist",
      function () {
        return require("private-next-pages/jobs/data-scientist/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/data-scientist"])
      });
    }
  